import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import DropdownSelect from './DropDownSelect';
import Checkbox from './SelectionBox';

const ClassContentWrapper = (props) => {
  const {
    items,
    handleBatchSelect,
    setSelectedItems,
    isAllItemSelected,
    selectedItems,
    dropDownSelectCloseText,
    showAssigned,
    resourceShareData,
    savedClasses,
    cachedAssignData,
    renderAssignedOnValue,
  } = props;

  return (
    <Fragment>
      <div className="classes-selector__title-container">
        <p className="dark-bold-text">
          Which classes will receive a To-Do card?
        </p>
        {items.length === 1 && savedClasses.length === 1 && showAssigned && (
          <p className="dark-bold-text">Assigned On:</p>
        )}
      </div>
      <div className="class-selector-content-wrapper">
        {items.length > 1 && (
          <DropdownSelect
            handleBatchSelect={handleBatchSelect}
            setSelectedItems={setSelectedItems}
            isAllItemSelected={isAllItemSelected}
            items={items}
            selectedItems={selectedItems}
            dropDownSelectCloseText={dropDownSelectCloseText}
            dropDownSelectOpenText="Choose Classes"
            showAssigned={showAssigned}
            resourceShareData={resourceShareData}
            savedClasses={savedClasses}
            cachedAssignData={cachedAssignData}
            renderAssignedOnValue={renderAssignedOnValue}
          />
        )}
        {items.length === 1 && (
          <Fragment>
            <Checkbox
              key={items[0].id}
              checked={selectedItems.some(
                (selectdItemId) => selectdItemId === items[0].id,
              )}
              onClick={() => setSelectedItems(items[0].id)}
              label={items[0].name}
            />
            {renderAssignedOnValue(
              showAssigned,
              savedClasses,
              resourceShareData,
              cachedAssignData,
              items[0],
            )}
          </Fragment>
        )}
      </div>
    </Fragment>
  );
};

ClassContentWrapper.propTypes = {
  items: PropTypes.array.isRequired,
  isAllItemSelected: PropTypes.bool.isRequired,
  selectedItems: PropTypes.array,
  dropDownSelectCloseText: PropTypes.string.isRequired,
  handleBatchSelect: PropTypes.func,
  setSelectedItems: PropTypes.func,
  renderAssignedOnValue: PropTypes.func,
};

ClassContentWrapper.defaultProps = {
  handleBatchSelect: () => {},
  setSelectedItems: () => {},
  selectedItems: [],
  renderAssignedOnValue: () => {},
};

export default ClassContentWrapper;
